module.exports = __webpack_public_path__ + "img/dashboard 4 (1) 1 (1).4b38c265.jpg";